var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYellowS1({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.0154 18C12.6117 18 12.209 17.8963 11.8509 17.7016L9.11583 16.2111C9.04495 16.1718 8.95597 16.1718 8.88457 16.2111L6.14952 17.7016C5.79191 17.8963 5.38926 18 4.98553 18C4.45323 18 3.94459 17.828 3.51445 17.5045C2.73936 16.9195 2.3576 15.9479 2.51854 14.9683L3.04206 11.809C3.0558 11.7258 3.02887 11.6415 2.97009 11.5818L0.757428 9.34573C0.0707905 8.65145 -0.172033 7.63252 0.124053 6.68651C0.421228 5.73991 1.19576 5.06331 2.14445 4.92089L5.20248 4.46011C5.28323 4.44816 5.35298 4.39575 5.38926 4.31946L6.75705 1.44609C7.18058 0.554749 8.04026 0 9.00048 0C9.96014 0 10.8198 0.554749 11.2439 1.44667L12.6117 4.31949C12.6479 4.39582 12.7177 4.4482 12.7985 4.46016L15.856 4.92093C16.8052 5.06331 17.5792 5.73995 17.8758 6.68538C18.1725 7.63252 17.9296 8.65148 17.243 9.34573L15.0298 11.5823C14.9716 11.6415 14.9452 11.7258 14.9589 11.8101L15.4813 14.9672C15.6428 15.9484 15.261 16.9201 14.4854 17.5045C14.0558 17.828 13.5477 18 13.0154 18Z",
    fill: "#F8B30D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYellowS1);
export default __webpack_public_path__ + "static/media/yellow_s_1.73c3335c32ae5820816e11361e711494.svg";
export { ForwardRef as ReactComponent };